import { inject, Injectable } from '@angular/core';
import {
  BehaviorSubject,
  catchError,
  filter,
  Observable,
  of,
} from 'rxjs';
import { HttpClient } from '@angular/common/http';



export interface MajaConfigResponse {
  igstatic: string;
}

@Injectable({
  providedIn: 'root',
})
export class MajaConfigService {
  readonly #http = inject(HttpClient);

  #initialized = new BehaviorSubject(false);
  #igstatic = '/igstatic'; // fallback via proxy




  get ready$(): Observable<boolean> {
    return this.#initialized.asObservable();
  }

  get igStatic() {
    return this.#igstatic;
  }


  /**
   * Fetch the config via API
   */
  async loadApiConfig(majaUrl: string) {
    return new Promise<void>((_resolve, _reject) => {
      this.#http.get<MajaConfigResponse>(majaUrl.replace(/\/$/, '') + '/config').pipe(
        catchError(err => {
          _reject(err);
          return of(undefined);
        }),
        filter(res => !!res)
      ).subscribe(res => {
        this.#igstatic = res.igstatic;
        document.documentElement.style.setProperty('--igstatic', this.#igstatic);

        this.logConfigToConsole();
        this.#initialized.next(true);
        _resolve();

      });
    });
  }





  private logConfigToConsole() {
    if (
      window.location.hostname == 'localhost'
    ) {
      console.group('%cCurrent Maja Config 🐝', 'color:rgb(255, 218, 106);font-size: 20px;');
      console.log('%cigstatic: ' + this.#igstatic, 'color: #6bb7c4;');
      console.groupEnd();
    }
  }
}
